// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Billing — workspace-level agent list (/billing). One card per agent with its
   current plan + status and a "Manage billing" button into /billing/:botId. */

.billing-page {
  font-family: "DM Sans", sans-serif;
  max-width: 1100px;
  margin: 0;
  padding: 28px 24px 48px;
  box-sizing: border-box;
}

.billing-page .loading-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 320px;
}
.billing-page .main-loading-spinner {
  font-size: 28px;
  color: #5616ea;
}

/* ── Empty state ─────────────────────────────────────────────────────── */
.billing-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 60px 24px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  text-align: center;
}
.billing-empty p {
  margin: 0;
  color: #6b7280;
  font-size: 15px;
}
.billing-empty-cta {
  border: none;
  background: #5616ea;
  color: #fff;
  font-weight: 600;
  font-size: 14px;
  padding: 10px 22px;
  border-radius: 9px;
  cursor: pointer;
  transition: background 0.15s ease;
}
.billing-empty-cta:hover {
  background: #4a14d6;
}

/* ── Agent grid ──────────────────────────────────────────────────────── */
.billing-agent-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 18px;
}

.billing-agent-card {
  display: flex;
  flex-direction: column;
  gap: 16px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  padding: 18px;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;
}
.billing-agent-card:hover {
  border-color: #d6c9ff;
  box-shadow: 0 12px 28px -18px rgba(86, 22, 234, 0.45);
}

.billing-agent-top {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}
.billing-agent-avatar {
  flex: 0 0 auto;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #6a2bff 0%, #5616ea 100%);
  color: #fff;
  font-weight: 700;
  font-size: 17px;
}
.billing-agent-headings {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.billing-agent-name {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #20202a;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.billing-agent-provider {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: #6b7280;
  text-transform: uppercase;
}

/* ── Plan + status row ───────────────────────────────────────────────── */
.billing-agent-meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
.billing-agent-plan {
  display: inline-flex;
  align-items: center;
  font-size: 13px;
  font-weight: 700;
  color: #5616ea;
  background: #f1ecff;
  padding: 4px 12px;
  border-radius: 999px;
}
.billing-agent-status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12.5px;
  font-weight: 500;
  color: #4b5563;
}
.billing-agent-status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #9ca3af;
  flex: 0 0 auto;
}
.billing-agent-status.active .billing-agent-status-dot,
.billing-agent-status.trialing .billing-agent-status-dot {
  background: #22c55e;
}
.billing-agent-status.ending .billing-agent-status-dot {
  background: #f59e0b;
}
.billing-agent-status.past-due .billing-agent-status-dot {
  background: #ef4444;
}
.billing-agent-status.past-due {
  color: #b91c1c;
  font-weight: 600;
}
.billing-agent-status.cancelled .billing-agent-status-dot {
  background: #ef4444;
}
.billing-agent-status.free .billing-agent-status-dot {
  background: #c4b5fd;
}

/* ── Manage button ───────────────────────────────────────────────────── */
.billing-manage-btn {
  margin-top: auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  border: 1px solid #5616ea;
  background: #5616ea;
  color: #fff;
  font-weight: 600;
  font-size: 14px;
  padding: 10px 16px;
  border-radius: 10px;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}
.billing-manage-btn:hover {
  background: #4a14d6;
  border-color: #4a14d6;
}
.billing-manage-btn svg {
  font-size: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Billing.css"],"names":[],"mappings":"AAAA;8EAC8E;;AAE9E;EACE,kCAAkC;EAClC,iBAAiB;EACjB,SAAS;EACT,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,2EAA2E;AAC3E;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;AACA;EACE,mBAAmB;AACrB;;AAEA,2EAA2E;AAC3E;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,gFAAgF;AAClF;AACA;EACE,qBAAqB;EACrB,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;EAC7D,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,2EAA2E;AAC3E;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA,2EAA2E;AAC3E;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,0DAA0D;AAC5D;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,eAAe;AACjB","sourcesContent":["/* Billing — workspace-level agent list (/billing). One card per agent with its\r\n   current plan + status and a \"Manage billing\" button into /billing/:botId. */\r\n\r\n.billing-page {\r\n  font-family: \"DM Sans\", sans-serif;\r\n  max-width: 1100px;\r\n  margin: 0;\r\n  padding: 28px 24px 48px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.billing-page .loading-container {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-height: 320px;\r\n}\r\n.billing-page .main-loading-spinner {\r\n  font-size: 28px;\r\n  color: #5616ea;\r\n}\r\n\r\n/* ── Empty state ─────────────────────────────────────────────────────── */\r\n.billing-empty {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 16px;\r\n  padding: 60px 24px;\r\n  background: #ffffff;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 14px;\r\n  text-align: center;\r\n}\r\n.billing-empty p {\r\n  margin: 0;\r\n  color: #6b7280;\r\n  font-size: 15px;\r\n}\r\n.billing-empty-cta {\r\n  border: none;\r\n  background: #5616ea;\r\n  color: #fff;\r\n  font-weight: 600;\r\n  font-size: 14px;\r\n  padding: 10px 22px;\r\n  border-radius: 9px;\r\n  cursor: pointer;\r\n  transition: background 0.15s ease;\r\n}\r\n.billing-empty-cta:hover {\r\n  background: #4a14d6;\r\n}\r\n\r\n/* ── Agent grid ──────────────────────────────────────────────────────── */\r\n.billing-agent-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\r\n  gap: 18px;\r\n}\r\n\r\n.billing-agent-card {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n  background: #ffffff;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 14px;\r\n  padding: 18px;\r\n  transition: border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;\r\n}\r\n.billing-agent-card:hover {\r\n  border-color: #d6c9ff;\r\n  box-shadow: 0 12px 28px -18px rgba(86, 22, 234, 0.45);\r\n}\r\n\r\n.billing-agent-top {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  min-width: 0;\r\n}\r\n.billing-agent-avatar {\r\n  flex: 0 0 auto;\r\n  width: 40px;\r\n  height: 40px;\r\n  border-radius: 10px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: linear-gradient(135deg, #6a2bff 0%, #5616ea 100%);\r\n  color: #fff;\r\n  font-weight: 700;\r\n  font-size: 17px;\r\n}\r\n.billing-agent-headings {\r\n  min-width: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 2px;\r\n}\r\n.billing-agent-name {\r\n  margin: 0;\r\n  font-size: 15px;\r\n  font-weight: 600;\r\n  color: #20202a;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n.billing-agent-provider {\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  letter-spacing: 0.02em;\r\n  color: #6b7280;\r\n  text-transform: uppercase;\r\n}\r\n\r\n/* ── Plan + status row ───────────────────────────────────────────────── */\r\n.billing-agent-meta {\r\n  display: flex;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n  gap: 8px;\r\n}\r\n.billing-agent-plan {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  font-size: 13px;\r\n  font-weight: 700;\r\n  color: #5616ea;\r\n  background: #f1ecff;\r\n  padding: 4px 12px;\r\n  border-radius: 999px;\r\n}\r\n.billing-agent-status {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  font-size: 12.5px;\r\n  font-weight: 500;\r\n  color: #4b5563;\r\n}\r\n.billing-agent-status-dot {\r\n  width: 8px;\r\n  height: 8px;\r\n  border-radius: 50%;\r\n  background: #9ca3af;\r\n  flex: 0 0 auto;\r\n}\r\n.billing-agent-status.active .billing-agent-status-dot,\r\n.billing-agent-status.trialing .billing-agent-status-dot {\r\n  background: #22c55e;\r\n}\r\n.billing-agent-status.ending .billing-agent-status-dot {\r\n  background: #f59e0b;\r\n}\r\n.billing-agent-status.past-due .billing-agent-status-dot {\r\n  background: #ef4444;\r\n}\r\n.billing-agent-status.past-due {\r\n  color: #b91c1c;\r\n  font-weight: 600;\r\n}\r\n.billing-agent-status.cancelled .billing-agent-status-dot {\r\n  background: #ef4444;\r\n}\r\n.billing-agent-status.free .billing-agent-status-dot {\r\n  background: #c4b5fd;\r\n}\r\n\r\n/* ── Manage button ───────────────────────────────────────────────────── */\r\n.billing-manage-btn {\r\n  margin-top: auto;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 8px;\r\n  width: 100%;\r\n  border: 1px solid #5616ea;\r\n  background: #5616ea;\r\n  color: #fff;\r\n  font-weight: 600;\r\n  font-size: 14px;\r\n  padding: 10px 16px;\r\n  border-radius: 10px;\r\n  cursor: pointer;\r\n  transition: background 0.15s ease, border-color 0.15s ease;\r\n}\r\n.billing-manage-btn:hover {\r\n  background: #4a14d6;\r\n  border-color: #4a14d6;\r\n}\r\n.billing-manage-btn svg {\r\n  font-size: 12px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
